import pkg from '../package.json';
export const version = pkg.version;
export { compile } from './compile/compile';
export { normalize } from './normalize';
export * from './util';
//# sourceMappingURL=index.js.map